// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"a51b1df7","348":"a4ce7826","571":"835e5cb1","924":"a22f7ce7"}[chunkId] + ".chunk.js";
};